/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Comeback_PlanInputs */

const en_portal_goal_comeback_plan = /** @type {(inputs: Portal_Goal_Comeback_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A step-by-step plan, with a physio`)
};

const pl_portal_goal_comeback_plan = /** @type {(inputs: Portal_Goal_Comeback_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan krok po kroku, razem z fizjoterapeutą`)
};

/**
* | output |
* | --- |
* | "A step-by-step plan, with a physio" |
*
* @param {Portal_Goal_Comeback_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_comeback_plan = /** @type {((inputs?: Portal_Goal_Comeback_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Comeback_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_comeback_plan(inputs)
	return en_portal_goal_comeback_plan(inputs)
});